import {ListItemText, Menu, MenuItem, Tooltip} from "@mui/material";
import React from "react";
import {ToolbarButton} from "@mui/x-data-grid";
import {devopsClearCategorizationTableColumnSettings} from "../settings/CategorizationColumnSettings.ts";
import {devopsClearCategorizationTableSettings} from "../settings/CategorizationTableSettings.ts";
import SeeMoreIcon from '../../../../../../components/icons/svg/SeeMoreIcon.svg?react';
import {useStores} from "~/stores";
import {AdminPanelSettings} from "@mui/icons-material";

export const ToolbarMoreMenu: React.FC = () => {
    const {authStore, categorizationReviewStore} = useStores();
    const tableController = categorizationReviewStore.reviewPageController.reviewPageTableController;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return <>
        <Tooltip title="More options">
            <ToolbarButton
                color="primary"
                id="more-menu-button"
                onClick={handleOpen}>
                <SeeMoreIcon/>
            </ToolbarButton>
        </Tooltip>
        <Menu
            id="more-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
            transformOrigin={{vertical: 'top', horizontal: 'right'}}
        >
            <MenuItem onClick={() => {
                devopsClearCategorizationTableColumnSettings();
                devopsClearCategorizationTableSettings();
                window.location.reload();
            }}>
                <ListItemText>Reset table settings</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => tableController.resetStoredColumnOrder()}>
                <ListItemText>Reset column ordering</ListItemText>
            </MenuItem>
            <MenuItem onClick={() => tableController.resetVisibilityToDefault()}>
                <ListItemText>Reset columns visibility</ListItemText>
            </MenuItem>
            {authStore.isMithraStaff && <MenuItem onClick={() => {
                handleClose();
                tableController.downloadColumnListExcel();
            }}>
                <ListItemText><AdminPanelSettings/>Download column list</ListItemText>
            </MenuItem>}
        </Menu>
    </>
}
